// src/services/Payment_service.ts
import axios from "axios";
import { toast } from "react-toastify";


const API_URL = process.env.REACT_APP_API_URL || "";

export async function createPaymentIntent(amountEuros: number, description = "", saveForLater = false) {
  try {
    if (!amountEuros || amountEuros <= 0) {
      throw new Error("Le montant doit être positif et spécifié.");
    }
    const userId = localStorage.getItem("userId") || null;
    const amountInCents = Math.round(amountEuros * 100);

    console.log("[DEBUG] createPaymentIntent - Envoi :", { amountEuros, amountInCents, userId, description, saveForLater });

    const res = await axios.post(`${API_URL}/payments/create-payment`, {
      amount: amountInCents,
      userId,
      paymentMethod: "card",
      description,
      currency: "eur",
      saveForLater
    });

    console.log("[DEBUG] createPaymentIntent - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] createPaymentIntent :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la création du PaymentIntent.");
  }
}

export async function createTransaction(transactionData: {
  amount: number; // en centimes
  currency?: string;
  paymentMethod?: string;
  description?: string;
  paymentRef?: string;
  pointsUsed?: number
}) {
  try {
    const userId = localStorage.getItem("userId") || null;
    const body = { userId, ...transactionData };

    console.log("[DEBUG] createTransaction - Envoi :", body);

    const res = await axios.post(`${API_URL}/payments/create-transaction`, body);

    console.log("[DEBUG] createTransaction - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] createTransaction :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la création de la transaction.");
  }
}

export async function createFreeAnnonce(paymentRef: string) {
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    console.log("[DEBUG] createFreeAnnonce - start:", { userId, paymentRef, hasToken: !!token });

    if (!token) {
      return { success: false, message: "Token non trouvé" };
    }
    if (!userId) {
      return { success: false, message: "Utilisateur non connecté" };
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `${token}`,
    };

    const res = await axios.post(
      `${API_URL}/annonce/creer-annonce-gratuite`,
      { paymentRef, userIdInToken: userId },
      { headers }
    );

    console.log("[DEBUG] createFreeAnnonce - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] createFreeAnnonce :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la création de l'annonce gratuite.");
  }
}

export const createFreeAnnouncement = createFreeAnnonce;

export async function applyPointsForDiscount(pointsToUse: number) {
  try {
    const userId = localStorage.getItem("userId");
    if (!pointsToUse || pointsToUse <= 0) {
      throw new Error("Le nombre de points doit être positif.");
    }
    if (!userId) {
      throw new Error("Utilisateur non connecté.");
    }

    console.log("[DEBUG] applyPointsForDiscount - Envoi :", { userId, pointsToUse });

    const res = await axios.post(`${API_URL}/payments/use-points`, { userId, pointsToUse });

    console.log("[DEBUG] applyPointsForDiscount - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] applyPointsForDiscount :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de l'utilisation des points.");
  }
}

export async function updateAnnoncePoints(paymentRef: string) {
  try {
    if (!paymentRef) throw new Error("PaymentRef manquant.");

    console.log("[DEBUG] updateAnnoncePoints - Envoi :", { paymentRef });

    const res = await axios.post(`${API_URL}/payments/update-annonce-points`, { paymentRef });

    console.log("[DEBUG] updateAnnoncePoints - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] updateAnnoncePoints :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la mise à jour des points de l'annonce.");
  }
}

export async function getPointsByPaymentRef(paymentRef: string) {
  try {
    if (!paymentRef) throw new Error("PaymentRef manquant.");

    console.log("[DEBUG] getPointsByPaymentRef - PaymentRef :", paymentRef);

    const res = await axios.get(`${API_URL}/payments/points/${encodeURIComponent(paymentRef)}`);

    console.log("[DEBUG] getPointsByPaymentRef - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] getPointsByPaymentRef :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la récupération des points.");
  }
}

export async function getPointsSettings() {
  try {
    const res = await axios.get(`${API_URL}/points-settings`);
    console.log("[DEBUG] getPointsSettings - Réponse :", res.data);
    return res.data;
  } catch (err: any) {
    console.error("[ERROR] getPointsSettings :", err.response?.data || err.message || err);
    throw new Error(err.response?.data?.error || err.message || "Erreur lors de la récupération des paramètres des points.");
  }
}

 export const updateUserPoints = async (userId: string, newPoints: number, dispatch: any) => {
  try {
    const response = await axios.post(
      `${API_URL}/payments/update-user-points-balance/${userId}`,
      { points: newPoints },
      { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }
    );
    console.log("Response from update-user-points-balance:", response.data);

    toast.success("Points utilisateur mis à jour avec succès !");
  } catch (error) {
    toast.error("Erreur lors de la mise à jour des points utilisateur");
    console.error("Error details:", error);
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error("Erreur inconnue");
    }
  }
};